function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as c from './constants';
var initialState = {
  adDescription: '',
  advertisingImages: [],
  callToActionLinkText: '',
  callToActionUrl: '',
  imageUrl: '',
  status: {
    loaded: false,
    uploading: false,
    removing: false,
    selecting: false
  }
};
var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.status;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.ADVERTISING_IMAGES_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loaded: true
      });
    case c.ADVERTISING_IMAGE_REMOVAL_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        removing: true
      });
    case c.ADVERTISING_IMAGE_REMOVAL_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        removing: false
      });
    case c.ADVERTISING_IMAGE_UPDATE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        selecting: true
      });
    case c.ADVERTISING_IMAGE_UPDATE_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        selecting: false
      });
    case c.ADVERTISING_IMAGE_UPLOAD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: false,
        loaded: true
      });
    case c.ADVERTISING_IMAGE_UPLOAD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: true
      });
    case c.ADVERTISING_IMAGE_UPLOAD_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: false
      });
    default:
      return state;
  }
};
export var advertisingImagesReducer = function advertisingImagesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.ADVERTISING_IMAGES_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        advertisingImages: action.advertisingImages,
        callToActionUrl: action.callToActionUrl,
        status: status(state.status, action)
      });
    case c.CURRENT_ADVERTISING_IMAGES_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        adDescription: action === null || action === void 0 ? void 0 : action.adDescription,
        callToActionLinkText: action.callToActionLinkText,
        callToActionUrl: action.callToActionUrl,
        imageUrl: action.imageUrl,
        status: status(state.status, action)
      });
    case c.ADVERTISING_IMAGE_REMOVAL_REQUESTED:
    case c.ADVERTISING_IMAGE_UPDATE_COMPLETED:
    case c.ADVERTISING_IMAGE_UPDATE_REQUESTED:
    case c.ADVERTISING_IMAGE_UPLOAD_SUCCESS:
    case c.ADVERTISING_IMAGE_UPLOAD_REQUESTED:
    case c.ADVERTISING_IMAGE_UPLOAD_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: status(state.status, action)
      });
    case c.ADVERTISING_IMAGE_REMOVAL_COMPLETED:
      {
        var newAdvertisingImages = state.advertisingImages.filter(function (image) {
          return image.fileName !== action.fileName;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          advertisingImages: newAdvertisingImages,
          status: status(state.status, action)
        });
      }
    default:
      return state;
  }
};
export default advertisingImagesReducer;